<template>
    <div class="config-property">
        <div>
            Nome da filial exibido no texto do rodapé:
        </div>
        <label class="input-radio" v-for="(tipo, idx) in tipos" :key="idx">
            <div class="row">
                <div class="col-sm-1 mr-3">
                    <input type="radio" :value="tipo.value" name="TIPO_NOME_FILIAL_RODAPE" v-model="value.TIPO_NOME_FILIAL_RODAPE">
                </div>
                <div class="col-sm-11">
                    {{ tipo.label }}
                </div>
            </div>
        </label>
        <small class="text-muted">
            Aplica-se ao texto de endereços das filiais no rodapé do site.
        </small>
    </div>
</template>

<script>
  export default {
    name: "TIPO_NOME_FILIAL_RODAPE",
    props: [
      'value'
    ],
    data() {
      return {
        tipos: [
          {
            label: 'Nome fantasia',
            value: 'FANTASIA',
          },
          {
            label: 'Razão social',
            value: 'RAZAO_SOCIAL',
          },
        ]
      }
    }
  }
</script>
